var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 250,
    height: 250,
    rx: 125,
    fill: "#B4E5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.379 118.032V194.592H61.2148V118.032",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.379 118.032V194.592H61.2148V118.032",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8351 112.714L61.2148 118.032L117.974 167.314H133.632L190.111 118.032L178.927 112.714H157.398H72.8351Z",
    fill: "white",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9355 194.435L106.231 156.969",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.814 156.969L190.11 194.435",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.928 127.571V51H72.6797V127.611",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.928 127.571V51H72.6797V127.611",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.662,
    cy: 96.716,
    r: 27.6523,
    fill: "#322B92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.923 89.1884L137.013 86.3319C136.65 85.9699 136.157 85.7666 135.644 85.7666C135.131 85.7666 134.639 85.9699 134.276 86.3319L123.036 97.4038L123.023 97.3905L118.581 93.1143C118.216 92.7536 117.724 92.5518 117.211 92.5532C116.698 92.5545 116.207 92.7589 115.844 93.1215L112.934 96.0314C112.571 96.3951 112.367 96.8881 112.367 97.402C112.367 97.916 112.571 98.409 112.934 98.7727L121.618 107.502C121.798 107.682 122.012 107.825 122.247 107.923C122.483 108.02 122.735 108.071 122.99 108.071C123.244 108.071 123.497 108.02 123.732 107.923C123.967 107.825 124.181 107.682 124.361 107.502L139.929 91.937C140.11 91.7564 140.253 91.5419 140.35 91.3058C140.448 91.0698 140.497 90.8168 140.497 90.5614C140.496 90.3061 140.445 90.0533 140.347 89.8177C140.248 89.5821 140.104 89.3682 139.923 89.1884ZM122.99 106.133L114.307 97.4038L117.217 94.494L117.23 94.5073L121.672 98.7836C122.036 99.1434 122.526 99.3453 123.038 99.3453C123.549 99.3453 124.039 99.1434 124.403 98.7836L135.653 87.7044L138.555 90.5657L122.99 106.133Z",
    fill: "#4FC3F7",
    stroke: "#4FC3F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.379 118.032L133.072 167.504H117.974L61.2148 118.032",
    stroke: "#999EC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.c5863270946ca02efe68cb77fd3fa3e3.svg";
export { ForwardRef as ReactComponent };